import { Link, useLocation } from 'react-router-dom';
import { Calculator, MessageCircle } from 'lucide-react';
import { whatsappLink } from '@/lib/constants';

export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  // Hide on the calculator itself
  if (pathname.startsWith('/calculator')) return null;

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-3 inset-x-3 z-40"
    >
      <div className="bg-[#121212]/85 backdrop-blur-xl border border-white/10 rounded-full p-1.5 flex items-center gap-2 shadow-[0_10px_60px_rgba(0,0,0,0.6)]">
        <Link
          to="/calculator"
          data-testid="sticky-calculate-btn"
          className="flex-1 flex items-center justify-center gap-2 rounded-full bg-[#FFD400] px-5 py-3.5 text-[12px] font-poppins font-bold uppercase tracking-wide text-[#07111F]"
        >
          <Calculator className="h-4 w-4" /> Calculate Claim
        </Link>
        <a
          href={whatsappLink()}
          target="_blank"
          rel="noreferrer noopener"
          data-testid="sticky-whatsapp-btn"
          className="flex items-center justify-center gap-2 rounded-full border border-white/10 bg-transparent px-5 py-3.5 text-[12px] font-inter font-semibold text-white"
        >
          <MessageCircle className="h-4 w-4 text-[#39A8FF]" /> WhatsApp
        </a>
      </div>
    </div>
  );
}
